import Loadable from 'react-loadable';
import Loading from 'components/Loading';
import { AppSettings } from '../constants';
import auth from 'Auth/authenticator';

const ScheduledEmailActivity = Loadable({
  loader: () => import('./Containers/scheduled-email-activity'),
  loading: Loading
});

export default [
  {
    path: '/scheduled-email',
    component: ScheduledEmailActivity,
    private: true,
    name: 'Builders',
    portal: ['Builder'],
    menu: {
      name: 'Email activities',
      iconClass: 'pe-7s-mail',
      order: 14,
      className:
        auth.getRoleName() !== AppSettings.BUILDER_USER ? 'menu-divide' : '',
      condition: () => {
        return (
          AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI
        );
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/Activities/routes.js